import './AdminLoader.css';
import './adminShared.css';

const COLUMN_TYPES = {
  id: 'admin-skeleton--id',
  thumb: 'admin-skeleton--thumb',
  title: 'admin-skeleton--title',
  meta: 'admin-skeleton--meta',
  actions: 'admin-skeleton--actions',
};

function AdminTableLoader({ headers, columns, rows = 8 }) {
  return (
    <div className="admin-table-wrap" aria-busy="true" aria-live="polite">
      <table className="admin-table">
        <thead>
          <tr>
            {headers.map((header) => (
              <th
                key={header}
                className={header === 'Actions' ? 'admin-table__actions' : undefined}
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }, (_, index) => (
            <tr key={`loading-row-${index}`} className="admin-table__row--loading">
              {columns.map((column) => (
                <td
                  key={column}
                  className={column === 'actions' ? 'admin-table__actions' : undefined}
                >
                  <span className={`admin-skeleton ${COLUMN_TYPES[column]}`} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default AdminTableLoader;
